<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">How long is your school program?</h2>
        </div>

        <div class="step-body">
            <div class="months-input-container">
                <v-text-field
                    v-model.number="programLength"
                    type="number"
                    :min="1"
                    :max="120"
                    outlined
                    hide-details
                    class="months-input"
                >
                    <template v-slot:append>
                        <div class="months-controls">
                            <v-btn icon small @click="increment" :disabled="programLength >= 120">
                                <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>
                            <v-btn icon small @click="decrement" :disabled="programLength <= 1">
                                <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-text-field>
                <span class="months-label">Months</span>
            </div>
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="!isValid"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LeaseLengthStep',

    computed: {
        programLength: {
            get() {
                return this.$store.getters['Questionnaire/getAnswer']('programLength') || 12;
            },
            set(value) {
                const numValue = parseInt(value, 10);
                if (!isNaN(numValue) && numValue >= 1 && numValue <= 120) {
                    this.$store.dispatch('Questionnaire/setAnswer', {
                        key: 'programLength',
                        value: numValue
                    });
                }
            }
        },
        isValid() {
            return this.programLength && this.programLength >= 1;
        }
    },

    methods: {
        increment() {
            if (this.programLength < 120) {
                this.programLength = this.programLength + 1;
            }
        },
        decrement() {
            if (this.programLength > 1) {
                this.programLength = this.programLength - 1;
            }
        },
        onNext() {
            if (this.isValid) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
}

.step-body {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 24px;
}

.months-input-container {
    display: flex;
    align-items: center;
    gap: 16px;
}

.months-input {
    max-width: 120px;
}

.months-input >>> input {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
}

.months-input >>> input::-webkit-outer-spin-button,
.months-input >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.months-input >>> input[type=number] {
    -moz-appearance: textfield;
}

.months-controls {
    display: flex;
    flex-direction: column;
}

.months-controls .v-btn {
    height: 24px !important;
    width: 24px !important;
}

.months-label {
    font-size: 18px;
    font-weight: 500;
    color: #333;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}
</style>

<style>
.v-text-field--enclosed .v-input__append-inner{
    margin-top: 5px !important;
}
</style>
